<template>
  <div v-if="linkUrl">
    <nuxt-link :to="linkUrl" :class="classSelection">
      <div class="w-full h-full flex justify-center items-center">
        <span v-if="!isRoundBtn">{{ text }}</span>
        <div
          v-if="(icon && !disabled) || loading"
          class="h-24 w-24 ml-12"
          :class="{ 'absolute right-24': isBlock }"
        >
          <fa
            v-if="loading"
            key="spinner"
            class="text-sm"
            :icon="['fal', 'spinner']"
            :spin="true"
          />
          <fa
            v-else
            :key="icon"
            class="text-sm"
            :icon="[iconLib, icon]"
          />
        </div>
      </div>
    </nuxt-link>
  </div>
  <div
    v-else
    :class="{
      'inline-flex': !isBlock,
      block: isBlock,
    }"
  >
    <div
      :class="classSelection"
      class="flex-shrink-0"
      @click="$emit('clicked')"
    >
      <span v-if="!isRoundBtn" class="flex-shrink-0">{{ text }}</span>
      <div
        v-if="(icon && !disabled) || loading"
        :class="{
          'ml-8': !isRoundBtn,
        }"
      >
        <fa
          v-if="loading"
          key="spinner"
          class="text-sm"
          :icon="['fal', 'spinner']"
          :spin="true"
        />
        <fa
          v-else
          :key="icon"
          class="text-sm"
          :icon="[iconLib, icon]"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    isBlock: {
      type: Boolean,
      required: false,
      default: false,
    },
    linkUrl: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    iconLib: {
      type: String,
      required: false,
      default: 'fal',
    },
    isNarrowIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLargeBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSmallBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRoundBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSecondaryBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDangerBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGhostBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: [ 'clicked' ],
  computed: {
    classSelection(): { [name: string]: boolean } {
      return {
        btn: true,
        'btn--locked': this.disabled || this.loading,
        'btn--lg': this.isLargeBtn,
        'btn--md': !this.isLargeBtn && !this.isSmallBtn,
        'btn--sm': this.isSmallBtn,
        'btn--round': this.isRoundBtn,
        'btn--primary': !this.isSecondaryBtn && !this.isDangerBtn,
        'btn--secondary': this.isSecondaryBtn && !this.isDangerBtn,
        'btn--danger': this.isDangerBtn,
        'btn--ghost': this.isGhostBtn,
        'w-full': this.isBlock,
      };
    },
  },
});
</script>
<style>
</style>
